import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { createCarrierStatementFailed, createCarrierStatementSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT, OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* createCarrierStatement(action) {
  try {
    if (!action.payload) {
      throw new Error('ID not found');
    }
    const url = `${BACKEND_URL}/registries/carriers/${action.payload}/create-statement`;
    const response = yield makeRequest(url, {}, action, 'POST', true);
    if (response.status === NO_CONTENT) {
      yield put(createCarrierStatementSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const data = yield getBodyJson(response);
      yield put(createCarrierStatementFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createCarrierStatementFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
